<div class="card-list-container">
  <app-card title="URGENCY" titleColor="#F11516" btnTextColor="#F11516"></app-card>
  <app-card title="STUDENT" titleColor="#1767E5" ></app-card>
  <app-card title="SPECIALIST" titleColor="#6B41E9" ></app-card>
  <app-card title="NURSING" titleColor="#35DB93" btnTextColor="#35DB93"></app-card>
</div>
